module.exports = function (fox) {
	"use strict";

	require('./stylus/_userPersonalData.styl');
	require('fox-dynamic-injection!fox-template-loader!./templates.tpl')(fox);
	require('./widget/userPersonalData.js')(fox);
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-personal-data/index.js
// module id = 563
// module chunks = 4